// eslint-disable-next-line import/no-anonymous-default-export
export default {
  common: {
    yes: "हाँ",
    no: "नहीं",
    na: "लागू नहीं",
    
    good: "अच्छा",
    satisfactory: "संतोषजनक",
    poor: "खराब",
    
    shgs: "स्वयं सहायता समूह (SHG)",
    others: "अन्य",
    
    other: "अन्य",
    other_material: "अन्य सामग्री",
    other_materials: "अन्य सामग्री",
    
    not_applicable: "लागू नहीं",
    
    thermocol_plates: "थर्मोकोल प्लेट",
    aluminium_foil_plates: "एल्यूमिनियम फॉयल प्लेट",
    aluminium_foil_packets: "एल्यूमिनियम फॉयल पैकेट",
    
    steel_plates: "स्टील प्लेट",
    plastic_plates: "प्लास्टिक प्लेट",
    
    single_use_plastic_containers: "एकल उपयोग प्लास्टिक कंटेनर",
    
    remarks: "टिप्पणी",
    
    from: "से",
    to: "तक",
    
    capture_or_upload_photo: "फोटो लें या अपलोड करें",
    
    upload_document: "दस्तावेज़ अपलोड करें",
    upload_supporting_file: "सहायक दस्तावेज़ अपलोड करें",
    
    last_refill_date: "अंतिम रीफिल तिथि",
    last_pest_control_date: "अंतिम कीट नियंत्रण तिथि",
    last_health_checkup_date: "अंतिम स्वास्थ्य जांच तिथि",
    last_tank_cleaning_date: "अंतिम टैंक सफाई तिथि",
    last_water_quality_testing_date: "अंतिम जल गुणवत्ता परीक्षण तिथि",
  },
  home: {
    findCanteen: "कैंटीन खोजें",
    subtitle: "कैंटीनों की सूची प्राप्त करने के लिए स्थान विवरण चुनें।",
    district: "जिला",
    municipality: "नगरपालिका",
    ward: "वार्ड",
    canteenType: "कैंटीन का प्रकार",
    searchCanteens: "कैंटीन खोजें",
    searching: "खोजा जा रहा है...",
    startSurvey: "सर्वे शुरू करें",
    viewSurvey: "सर्वे देखें",
    searchResults: "खोज परिणाम",
  },

  survey: {
    fullAddInput: "सुविधा का पूरा पता",
    instruction1: "भरने के लिए किसी अनुभाग पर टैप करें — सबमिट करने के लिए सभी अनुभाग पूरे करें",
    "save&continue": "सहेजें और आगे बढ़ें →",
    saving: "सहेजा जा रहा है...",
    saveSection: "अनुभाग सहेजें",
    submitSurvey: "सर्वे जमा करें",
    backtosection: "← वापस",
  },

  surveyForms: {
    kiosk: {
      title: "कियोस्क सर्वे",
      description: "माँ कैंटीन कियोस्क का मूल्यांकन",
    },
    kitchen: {
      title: "रसोई सर्वे",
      description: "माँ कैंटीन रसोई का मूल्यांकन",
    },
    'kitchen-cum-dining': {
      title: "रसोई सह भोजनालय सर्वे",
      description: "माँ कैंटीन रसोई सह भोजनालय का मूल्यांकन",
    },
  },

  settings: {
    title: "सेटिंग्स",
    subtitle: "अपने खाते की जानकारी प्रबंधित करें।",
    signedInAccount: "साइन इन किया गया खाता",
    noUserDetails: "इस खाते के लिए कोई उपयोगकर्ता विवरण उपलब्ध नहीं है।",
    surveyLanguage: "सर्वे भाषा",
    selectLanguage: "भाषा चुनें",
    languageDescription: "प्रश्न चयनित भाषा में दिखाई देंगे।",
    logout: "लॉग आउट",
    user: "उपयोगकर्ता",
    notAvailable: "उपलब्ध नहीं",
    yes: "हाँ",
    no: "नहीं",
    english: "English",
    bengali: "বাংলা",
  },

  location: {
    title: "स्थान सेटिंग्स",
    subtitle:
      "स्थान आधारित कार्यों के लिए वेबसाइट को आपकी वर्तमान स्थिति का उपयोग करने की अनुमति दें।",
    accessEnabled: "स्थान एक्सेस सक्षम है",
    accessRequired: "स्थान एक्सेस आवश्यक है",
    accessBlocked: "स्थान एक्सेस अवरुद्ध है",
    accessUnsupported: "स्थान समर्थित नहीं है",
    requesting: "स्थान एक्सेस का अनुरोध किया जा रहा है",
    permissionTitle: "स्थान अनुमति",
    permissionDescription:
      "स्थान आधारित कार्यप्रवाहों के लिए इस वेबसाइट पर स्थान की आवश्यकता है।",
    browserPermissionMessage:
      "अपने ब्राउज़र से स्थान एक्सेस की अनुमति देने के लिए बटन पर क्लिक करें।",
    accessDescription:
      "अपने ब्राउज़र से स्थान एक्सेस की अनुमति देने के लिए बटन पर क्लिक करें।",
    notNow: "अभी नहीं",
    checking: "जाँच की जा रही है...",
    close: "बंद करें",
    allowLocation: "स्थान की अनुमति दें",
    latitude: "अक्षांश",
    longitude: "देशांतर",
    accuracy: "सटीकता",
    meters: "मीटर",
    manualTitle: "स्थान मैन्युअल रूप से चालू करें",
    chromeTitle: "Chrome या Edge",
    chromeDescription:
      "एड्रेस बार में लॉक आइकन पर क्लिक करें, Site Settings खोलें, Location को Allow पर सेट करें, फिर पेज को रिफ्रेश करें।",
    firefoxTitle: "Firefox",
    firefoxDescription:
      "एड्रेस बार में स्थान आइकन पर क्लिक करें, अवरुद्ध अनुमति हटाएँ, फिर दोबारा स्थान का अनुरोध करें।",
    androidTitle: "Android",
    androidDescription:
      "ब्राउज़र सेटिंग्स खोलें, Site Settings में जाएँ, Location चुनें और इस वेबसाइट को अनुमति दें।",
    iosTitle: "iPhone या iPad",
    iosDescription:
      "Settings खोलें, ब्राउज़र चुनें, Location चालू करें, फिर संकेत मिलने पर इस वेबसाइट को अनुमति दें।",
  },

  navbar: {
    logo: "माँ कैंटीन मॉनिटरिंग",
    logoShort: "माँ कैंटीन",
    wbgovt: "पश्चिम बंगाल सरकार",
    home: "होम",
    survey: "सर्वे",
    settings: "सेटिंग्स",
  },
};